export const getElements = state => state.elements.map( item => {
  let { content } = item
  if( typeof content === 'string' ) {
    content = JSON.parse( content )
  }
  return {
    ...item,
    content: content
  }
} )
export const getActiveElement = state => state.actualElement
export const getRawElements = state => state.elements
export const getElementById = ( state, id ) => {
  const item = state.elements.find( el => +el.id === +id )
  if( item && typeof item.content === 'string' ) {
    item.content = JSON.parse( item.content )
  }
  return item
}
export const getElementIndex = ( state, id ) => state.elements.findIndex( e => +e.id === +id )


// WEBPACK FOOTER //
// ./src/store/getters/elements.js